@file:OptIn(ExperimentalUuidApi::class)

package com.appcreator.client.firebase.storage

import androidx.compose.runtime.Composable
import com.appcreator.blueprint.core.EnvStore
import com.appcreator.blueprint.firebase.storage.FirebaseStorageDeleteAction
import com.appcreator.compose.actions.Performer
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.storage.storage
import kotlin.uuid.ExperimentalUuidApi

class DeletePerformer(private val action: FirebaseStorageDeleteAction): Performer {

    @Composable
    override fun deferred(): Performer.Deferred {
        return object : Performer.Deferred {
            override suspend fun perform(envStore: EnvStore) {
                action.path?.let {
                    val path = envStore.injectVariables(it)
                    val ref = Firebase.storage.reference.child(path)
                    ref.delete()
                }
            }
        }
    }
}

